import { COLLECTIONS, STATUSES } from '__constants__'
import { deleteDocument, updateDocument } from 'services/api/firebase'
import { generatePath, useHistory } from 'react-router-dom'

import PATHS from 'pages/paths'
import { message } from 'antd'
import { useEvent } from 'hooks'
import { useMemo } from 'react'
import { useTranslations } from 'contexts/Translation'

/* Path's */
const createPath = PATHS.AUTHENTICATED.EMAIL_CREATE
const editPath = PATHS.AUTHENTICATED.EMAIL_EDIT

const useEmailBaseActions = ({
  emailId,
  actions,
  isBlocked,
  isEditor,
  status
} = {}) => {
  /* Getting translations instance */
  const { t } = useTranslations()
  /* Getting history instance */
  const history = useHistory()

  /* Function to handle back click */
  const handleBack = useEvent(() => history.goBack())

  /* Handling opening of the create page */
  const handleCreate = useEvent(() => {
    history.push(createPath)
  })

  /* Handling opening of the edit page or change view to edit mode */
  const handleEdit = useEvent(() => {
    const pathParams = { emailId }
    const path = generatePath(editPath, pathParams)
    history.push(path)
  })

  const handleDelete = useEvent(async () => {
    try {
      await deleteDocument(COLLECTIONS.EMAILS, emailId)
      message.success(t('Email successfully deleted'))
    } catch (error) {
      message.error(error.message)
    }
  })

  const handleBlock = useEvent(async () => {
    const computedStatus = isBlocked ? 'unblocked' : 'blocked'
    try {
      await updateDocument(COLLECTIONS.EMAILS, emailId, {
        isBlocked: !isBlocked,
        status: isBlocked
          ? STATUSES.EMAIL_STATUSES.ACTIVE
          : STATUSES.EMAIL_STATUSES.BLOCKED
      })
      message.success(t(`Email successfully ${computedStatus}`))
    } catch (error) {
      console.error(t(`Error ${computedStatus} status`, error.message))
      message.error(t(`Error ${computedStatus} status`, error.message))
    }
  })

  return useMemo(
    () => ({
      onBack: handleBack,
      onCreate: handleCreate,
      onEdit: !isEditor && handleEdit,
      onDelete: !isEditor && handleDelete,
      onBlock: handleBlock,
      ...(actions || {}),
      createPath,
      editPath
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      actions?.onBack,
      actions?.onCreate,
      actions?.onDelete,
      actions?.onEdit,
      handleBack,
      handleCreate,
      handleDelete,
      handleEdit,
      handleBlock
    ]
  )
}

export default useEmailBaseActions
